module.exports = __webpack_public_path__ + "media/directory/avatar_icon-88372848.svg";